import angular from 'angular';
import _ from 'lodash';

(function() {
    'use strict';

    angular.module('app.core').component('kissSellerAutocompleteFilter', {
        bindings: {
            sellerSelected: '=',
            duplicateSeller:'@', // True pour autoriser l'affichage de plusieurs fournisseurs appartenent à la même société. False pour dédoublonner. False par défaut
            status:'@'			 // Filtre sur un statut
        },
        controller: SellerAutocompleteFilterController,
        templateUrl: require('./seller-autocomplete-filter.html')
    });

    SellerAutocompleteFilterController.$inject = ['KissSellerSvc'];

    function SellerAutocompleteFilterController(KissSellerSvc) {
        var ctrl = this;

        ctrl.searchSellers = searchSellers;

        /**
         * Recherche des fournisseurs en autocomplétion.
         */
        function searchSellers(value) {
            if (value && value.length >= 3) {
                return KissSellerSvc.searchSellers(value).then(function(sellers) {
                	var sellersFiltered;
                	if (ctrl.duplicateSeller) {
                		sellersFiltered = sellers;
                	} else {
                		sellersFiltered = _.uniqBy(sellers, 'legalEntity.id');
                	}
                	if (ctrl.status) {
                		sellersFiltered = _.filter(sellers, {status: ctrl.status})
                	} 
                	return sellersFiltered;
                });
            }
        }
    }
})();
